module.exports = __webpack_public_path__ + "img/logo_main.1e50d4aa.png";